import {
  Component,
  ViewEncapsulation,
  OnInit
} from '@angular/core';
import {
  State
} from '@progress/kendo-data-query';
import {
  DataStateChangeEvent,
  GridDataResult, SelectionEvent,
} from '@progress/kendo-angular-grid';
import {
  Observable
, Subscription} from 'rxjs';
import {
  FormControl
} from '@angular/forms';
import {Router} from '@angular/router';
import {UserContext} from "../services/user-context/user-context";
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ApiService} from '../services/api/api.service';
import {debounceTime, distinctUntilChanged} from "rxjs/operators";
import {LocationSummaryService} from '../services/location-summary-service/index';
import {ShopService} from './shop.service';



@Component({
  selector: 'app-shop',
  encapsulation: ViewEncapsulation.None,
  templateUrl: 'shop.template.html'
})
export class ShopComponent implements OnInit {
  public view: Observable<GridDataResult>;
  public subscription: Subscription;
  public state: State = {
    skip: 0,
    take: 10
  };

  loading = false;

  constructor(
    private router: Router,
    private service: ShopService,
    public dialog: MatDialog) {

    this.view = service;
    this.subscription = service.subscription;
    this.getESalels('');
  }

  public ngOnInit(): void {

  }

  /*
  public selectedRow(event: SelectionEvent) {
      this.userContext.account = event.selectedRows[0].dataItem;
      this.locationSummaryService.locationObserver.next(true);
      this.router.navigate(['', 'accounts', `${event.selectedRows[0].dataItem._id}`]);
  }*/

  public dataStateChange(state: DataStateChangeEvent): void {
    this.state = state;
    this.getESalels('');
  }

  public getESalels(locationId) {
    this.loading = true;
    const page = this.state.skip / this.state.take + 1;
    const limit = this.state.take;

    this.service.getList(page, limit, () => {
      this.loading = false;
    }, locationId);
  }

}
